import React from "react";
import { twMerge } from "tailwind-merge";

type IconButtonProps = {
  label: string;
  active?: boolean;
  size?: "sm" | "md";
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

function IconButton({
  label,
  active = false,
  size = "md",
  className,
  children,
  ...rest
}: IconButtonProps) {
  return (
    <button
      type="button"
      aria-label={label}
      title={label}
      className={twMerge(
        "inline-flex items-center justify-center rounded-full text-ink-secondary transition-colors cursor-pointer hover:bg-surface-inset active:bg-surface-raised",
        size === "md" ? "w-10 h-10" : "w-8 h-8",
        active && "bg-brand-gradient text-white hover:opacity-90",
        className
      )}
      {...rest}
    >
      {children}
    </button>
  );
}

export default IconButton;
